import { DataTable } from "@/components/data-table";
import { Form, useForm } from "@/components/form";
import { useGetAllCiudadesQuery } from "../api/get-all-ciudades";
import { formatString } from "@/shared/formats";
import { Ciudad } from "@/shared/types/ciudad";
import { IconButton, Stack, StackProps } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useFilters } from "@/components/filters";
import { useGetAllDepartamentosQuery } from "@/features/auxiliar/departamentos/api/get-all-departamentos";
import { useEffect } from "react";

interface CiudadSearchProps extends StackProps {
    onCiudadSelect?: (ciudad: Ciudad) => void,
    departamentoId?: string
}

export default function CiudadManualSearch({
    onCiudadSelect,
    departamentoId,
    ...props
}: CiudadSearchProps) {
    const departamentosQuery = useGetAllDepartamentosQuery({ departamentoId: departamentoId, pageSize: 25 });

    const filterData = useFilters({
        useURL: false,
        filters: [
            { type: "string", label: "Nombre", name: "nombre" },
            { type: "string", label: "Código", name: "codigo" },
            { type: "string", label: "Departamento", name: "departamentoId" },
            { type: "pagination" }
        ],

    });

    const queryResult = useGetAllCiudadesQuery(filterData.filterData);

    const filterForm = useForm({
        defaultValues: filterData.filterData,
        onSubmit: ({ value }) => filterData.setFilterData(value),
        closeModalOnSubmit: false,
        submitOnce: false,
    });

    useEffect(() => {
        if (departamentoId) {
            filterForm.setFieldValue("departamentoId", departamentoId);
            filterData.setFilterData({ ...filterData.filterData, departamentoId });
        }
    }, [departamentoId]);

    return <Stack minHeight={"70vh"} gap={3} {...props}>
        <Form form={filterForm} direction={"row"} flexWrap={"wrap"} gap={2} sx={{ zIndex: 1 }}>
            <Form.TextField name="nombre" label="Nombre" size="small" sx={{ minWidth: 150 }} />
            <Form.TextField name="codigo" label="Código" size="small" sx={{ minWidth: 120 }} />
            <Form.Select name="departamentoId" label="Departamento" size="small" sx={{ minWidth: 200, flex: 1 }}>
                {!departamentoId && <Form.Select.Option value="">Todos los departamentos</Form.Select.Option>}
                {departamentosQuery.data?.result?.map(d => (
                    <Form.Select.Option key={d.id} value={d.id}>{d.nombre}</Form.Select.Option>
                ))}
            </Form.Select>
            <Form.SubmitButton>Filtrar</Form.SubmitButton>
        </Form>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={queryResult.data?.result}
                loading={queryResult.isFetching}
                columns={[
                    { key: "codigo", header: "Código", render: row => formatString(row.codigo) },
                    { key: "nombre", header: "Nombre", render: row => formatString(row.nombre) },
                    { key: "departamentoNombre", header: "Departamento", render: row => formatString(row.departamentoNombre) },
                    {
                        header: "", align: "center", width: "auto",
                        render: ciudad => <IconButton onClick={() => onCiudadSelect && onCiudadSelect(ciudad)}>
                            <AddIcon />
                        </IconButton>
                    }
                ]}
            />
            <DataTable.Pagination queryResult={queryResult} filterData={filterData} />
        </DataTable>
    </Stack>
}
